import { createContext } from 'react';

/**
 * Where a portal lands: `undefined` means no slot is provided, so the content
 * renders in place; `null` means the slot exists but has not mounted yet, so the
 * content waits a render; an element is the slot itself.
 */
export type DockSlot = HTMLElement | null | undefined;

/**
 * The workspace's dock column. An `EditorDock` rendered anywhere under it lands
 * there, beside the canvas, so an editor keeps its place in the workspace's
 * component tree while it appears in the dock.
 */
export const EditorDockSlotContext = createContext<DockSlot>(undefined);

/** The pinned row at the bottom of the enclosing `EditorDock`, where `DockFooter` lands. */
export const DockFooterSlotContext = createContext<DockSlot>(undefined);
